
import icon1 from '../images/icon/quote.png'
import avt1 from '../images/layouts/avt-08.png'
import avt2 from '../images/layouts/team-10.jpg'


const dataTestimonials = [
    {
        id: 1,
        icon: icon1,
        text: '“Our team provides opportunities to overcome the limitations of offline human relationships and enables everyone to build social networks more easily"',
        avt: avt2,
        name: 'Shin yeongbin',
        position: 'CEO'
    },
    {
        id: 2,
        icon: icon1,
        text: '"When You\'re Going To Change The World, Don\'t Ask For Permission"',
        avt: avt1,
        name: 'RIOT GAMES',
        position: 'ARCANE SEASON ONE, EPISODE TWO'
    },

]

export default dataTestimonials;